import React, { useEffect } from 'react';
import Select from 'react-select';

const ReplyQuery = (props) => {
    const { reply, queryreason, addnewQueryList, handleChange, removeReply } = props;
    useEffect(() => {
    }, [])
    let reasontemplatesoption = [
        { value: "other", label: "Other" }
    ];

    if (Array.isArray(queryreason)) {
        reasontemplatesoption = [
            { value: "other", label: "Other" },
            ...queryreason
        ];
    } else {
        // Handle the case when queryreason is not an array
        // You can assign a default value or handle it differently based on your requirements
    }
    const selectMenuPortalTarget = typeof window !== "undefined" ? document.body : null;
    const selectMenuStyles = {
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    };
    return (
        <div className="main-body" style={{ marginBottom: "12px" }}>
            <div className="page-wrapper" style={{ paddingBottom: "8px" }}>
                {addnewQueryList && addnewQueryList.length
                    ? addnewQueryList.map(
                        (reply: any, index: number) => {
                            return (
                                <>
                                    <div className="row align-items-start" style={{ marginBottom: "14px" }}>
                                        <div className="col-md-3" style={{ flex: "0 0 40%", maxWidth: "40%", boxSizing: "border-box" }}>
                                            <div className="form-group" style={{ marginBottom: 0 }}>
                                                <label>Query</label>{" "}
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="query"
                                                    placeholder=""
                                                    value={reply.query}
                                                    onChange={(e) => handleChange(e, index)}
                                                />
                                            </div>
                                            {!reply.query && <p style={{ color: "red", fontSize: "14px", marginTop: "4px", marginBottom: 0 }}>Required field.</p>}
                                        </div>
                                        <div className="col-md-4" style={{ flex: "0 0 25%", maxWidth: "25%", boxSizing: "border-box" }}>
                                            <div className="form-group" style={{ marginBottom: 0 }}>
                                                <label>Reason</label>
                                                {queryreason && queryreason.length > 0 && queryreason.map((opt: any) => {
                                                    opt.label = opt.reason; opt.value = opt.reason
                                                }) && (
                                                        <Select
                                                            options={reasontemplatesoption}
                                                            name="reason"
                                                            onChange={(selectedOption) =>
                                                                props.handleDetailsChange(selectedOption.value, 'review', index)
                                                            }
                                                            value={reasontemplatesoption.find(
                                                                (o: any) => o.value === reply.review
                                                            )}
                                                            menuPortalTarget={selectMenuPortalTarget}
                                                            menuPosition="fixed"
                                                            styles={selectMenuStyles}
                                                        />
                                                    )}
                                                {!reply.review && <p style={{ color: "red", fontSize: "14px", marginTop: "4px", marginBottom: 0 }}>Required field.</p>}
                                                {reply.review === "other" && (
                                                    <div className="">
                                                        <label>Other Reason</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="other_review"
                                                            placeholder=""
                                                            value={reply.other_review}
                                                            onChange={(e) => handleChange(e, index)}
                                                        />
                                                        {!reply.other_review && <p style={{ color: "red", fontSize: "14px", marginTop: "4px", marginBottom: 0 }}>Required field.</p>}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ flex: "0 0 25%", maxWidth: "25%", boxSizing: "border-box" }}>
                                            <div className="form-group" style={{ marginBottom: 0 }}>
                                                <label>Location</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="location"
                                                    placeholder=""
                                                    value={reply.location}
                                                    onChange={(e) => handleChange(e, index)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-1" style={{ flex: "0 0 5%", maxWidth: "5%", boxSizing: "border-box", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "8px", minHeight: "38px", paddingLeft: "4px", paddingTop: "34px" }}>
                                            <div onClick={props.addReply} style={{ cursor: "pointer", lineHeight: 1, marginRight: "2px" }}>
                                                <i className="fa fa-plus-circle fa-icon" aria-hidden="true" ></i>
                                            </div>
                                            <div onClick={() => removeReply(index)} style={{ cursor: "pointer", lineHeight: 1, marginLeft: "2px" }}>
                                                <i className="fa fa-trash fa-icon" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            );
                        }
                    )
                    : ""}
            </div>
        </div>
    )
}

export default ReplyQuery;